import { render, staticRenderFns } from "./PartnerBanner.vue?vue&type=template&id=ef5a5be2&"
import script from "./PartnerBanner.vue?vue&type=script&lang=js&"
export * from "./PartnerBanner.vue?vue&type=script&lang=js&"
import style0 from "./PartnerBanner.vue?vue&type=style&index=0&id=ef5a5be2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports